var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWrapgiftslogo = function SvgWrapgiftslogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8DACFB",
    d: "M2 17.638h36v2H2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    x: 2,
    y: 18,
    fill: "#8DACFB",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD5959",
    d: "M15 18h10v24H15z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 12,
    y: 6.362,
    fill: "#B5C9FF",
    rx: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE4545",
    d: "M34.5 2.362c0 1.38-2.007 3.898-2.769 4-3.731.5.269-2.12.269-3.5S30.903 0 31.731 0 34.5.981 34.5 2.362Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE4545",
    d: "M32.5.362c3.357 2.869 0 3.5-.5 2-.553-1.66-8 3.5-8 2 0-.829 3.225-2.863 4.5-3.5 1-.5 4-1.329 4-.5ZM32.277 4.67C33.5 3.862 33 5.862 31 6.362c-2.485 0-6 .276-6 0-.5-1 2.791-1.192 5.277-1.192 2-.67.723-.308 2-.5ZM5 2.362c0 1.38 2.007 3.898 2.769 4 3.73.5-.269-2.12-.269-3.5S8.597 0 7.769 0C6.94 0 5 .981 5 2.362Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE4545",
    d: "M7 .362c-3.357 2.869 0 3.5.5 2 .553-1.66 8 3.5 8 2 0-.829-3.225-2.863-4.5-3.5-1-.5-4-1.329-4-.5ZM7.223 4.67C6 3.862 6.5 5.862 8.5 6.362c2.485 0 6 .276 6 0 .5-1-2.791-1.192-5.277-1.192-2-.67-.723-.308-2-.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE4545",
    d: "M26 6.376H14c0-2.217 2.686-4.014 6-4.014s6 1.797 6 4.014Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58181",
    d: "M14 6.362h12v12H14z"
  })));
};
export default SvgWrapgiftslogo;